import { apiFetch } from './authed-api';

export interface FetchJsonResult<T> {
  ok: boolean;
  status: number;
  data: T;
}

export async function fetchJson<T>(
  url: string,
  init?: RequestInit,
  timeoutMs = 35_000
): Promise<FetchJsonResult<T>> {
  const headers = (init?.headers as Record<string, string> | undefined) ?? {};
  const hasAuthHeader = Object.keys(headers).some((k) => k.toLowerCase() === 'authorization');
  const auth = hasAuthHeader ? 'dashboard' : ('none' as const);

  try {
    const response = await apiFetch(url, {
      ...init,
      auth,
      timeoutMs,
      headers,
    });
    const data = (await response.json()) as T;
    return { ok: response.ok, status: response.status, data };
  } catch (err) {
    if (err instanceof Error && err.message.includes('Tiempo de espera')) {
      throw new Error('Tiempo de espera agotado. La validación tardó demasiado; intentá de nuevo.');
    }
    throw err;
  }
}
